<template>
  <QuestionBase
      :question="question" :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
      :valid="!!data"
      :disabled-valid="true"
  >
    <InputBasic
        v-model="data"
        :db="db"
        :args="args"
        :skipped="skipped"
        :noSave="noSave"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../helpers/questionLoadHelpers";

import QuestionBase from "../../QuestionBase";
import InputBasic from "../../inputs/InputBasic";

export default {
  name: 'AmountPrevious',
  mixins: [questionLoadHelpers],
  components: {
    InputBasic,
    QuestionBase
  },
  props: {
    value: {
      type: [Number, String],
      required: false
    },
    title: {
      type: String,
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    objectId: {
      type: Number,
      required: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: this.title,
        subTitle: '',
        tip: null
      },
      db: {
        saveLocation: 'client_income',
        saveField: 'incomeCommonAmountPrevious',
        objectId: this.objectId
      },
      args: {
        placeholder: 'e.g. 20000',
        label: null,
        type: 'number',
        skippable: false,
        required: false,
        inputClass: 'field-66',
        prependText: '£'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>